import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { list, request, type PagedList } from "./client";
import type { ServiceName } from "./services";

/**
 * Ro'yxat so'rovi.
 *
 * Har bir modul o'z endpointini beradi, qolgan hammasi bir xil:
 * kalit, filtr, `signal`. Takrorlanadigan qism shu yerda
 * to'plangan — aks holda har bir modulda bir xil sakkiz qator
 * yozilardi va ularning biri boshqacha bo'lib qolardi.
 */
export function useList<T>(
  service: ServiceName,
  path: string,
  query: Record<string, string | number | boolean | undefined> = {},
  options: { enabled?: boolean; refetchInterval?: number } = {},
) {
  return useQuery({
    queryKey: [service, path, query],
    enabled: options.enabled ?? true,
    refetchInterval: options.refetchInterval,
    queryFn: ({ signal }) => list<T>(service, path, query, signal),
  });
}

/** Bitta obyekt so'rovi. */
export function useItem<T>(
  service: ServiceName,
  path: string,
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: [service, path],
    enabled: options.enabled ?? true,
    queryFn: ({ signal }) => request<T>(service, path, { signal }),
  });
}

/**
 * Mutatsiya.
 *
 * Muvaffaqiyatdan keyin shu servisning KESHI bekor qilinadi:
 * amal natijasi ro'yxatda darhol ko'rinishi kerak, aks holda
 * foydalanuvchi tugmani ikkinchi marta bosardi.
 */
export function useAction<TResult, TInput = void>(
  service: ServiceName,
  build: (input: TInput) => { path: string; method: "POST" | "PATCH" | "PUT" | "DELETE"; body?: unknown },
) {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (input: TInput) => {
      const spec = build(input);
      return request<TResult>(service, spec.path, {
        method: spec.method,
        body: spec.body ?? {},
      });
    },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: [service] });
    },
  });
}

export type { PagedList };
